export const config = {
  //   SERVER_URL: process.env.REACT_APP_BACKEND,
  SERVER_URL:
    process.env.REACT_APP_BACKEND || "https://api-staging.clanofraiders.com",
  referralLinkURL: process.env.REACT_APP_REFERRAL_LINK,
};
